import api from '@/services/api';

const DEFAULT_LOAD_LEADERBOARD = {
  data: [],
  trader: null,
  page: 0,
  totalCount: 0,
  canLoadMore: true,
};

export const TIME_OPTIONS = {
  PAST_WEEK: { label: 'Past Week', value: 7 },
  PAST_MONTH: { label: 'Past Month', value: 30 },
  PAST_YEAR: { label: 'Past Year', value: 365 },
};

export default {
  namespaced: true,
  state: {
    selectedLeaderboardId: null,
    playerLeaderboards: [],
    leaderboards: [],
    leaderboardsResults: Object.create(DEFAULT_LOAD_LEADERBOARD),
    leaderboardsDateRange: TIME_OPTIONS.PAST_WEEK.value,
  },
  getters: {
    selectedLeaderboard: (state) =>
      state.leaderboards.find((i) => i.leaderBoardId === state.selectedLeaderboardId),
  },
  mutations: {
    setSelectedLeaderboardId(state, data) {
      state.selectedLeaderboardId = data;
    },
    setPlayerLeaderboards(state, data) {
      state.playerLeaderboards = data;
    },
    setLeaderboards(state, data) {
      state.leaderboards = data;
    },
    clearSelectedLeaderboardId(state) {
      state.selectedLeaderboardId = null;
    },
    resetLeaderboardsResults(state) {
      state.leaderboardsResults = Object.create(DEFAULT_LOAD_LEADERBOARD);
    },
    setLeaderboardsResults(state, payload) {
      const sourceData = [...state.leaderboardsResults.data];
      const data = sourceData.concat(payload.data.traders || []);
      const page = payload.data.page;
      const totalCount = payload.data.totalTraders;
      const canLoadMore = totalCount > data.length;

      state.leaderboardsResults = {
        ...state.leaderboardsResults,
        trader: payload.data.trader,
        data,
        page,
        totalCount,
        canLoadMore,
      };
    },
    setLeaderboardsDateRange(state, data) {
      state.leaderboardsDateRange = data;
    },
    resetLeaderboardsDateRange(state) {
      state.leaderboardsDateRange = TIME_OPTIONS.PAST_WEEK.value;
    },
  },
  actions: {
    getLeaderboardsResults({ state, commit }) {
      if (state.selectedLeaderboardId !== null && state.leaderboardsResults.canLoadMore) {
        const page = state.leaderboardsResults.page + 1;
        return api.leaderboards
          .getLeaderboard({
            dateRange: state.leaderboardsDateRange,
            id: state.selectedLeaderboardId,
            page,
          })
          .then((response) => {
            commit('setLeaderboardsResults', {
              page,
              data: response.data,
            });
            return response.data;
          });
      }
      return null;
    },
    getLeaderboards({ state, commit }, { cache = true } = {}) {
      if (cache && state.leaderboards.length > 0) {
        return Promise.resolve(state.leaderboards);
      }
      return api.leaderboards.getLeaderboards().then((response) => {
        commit('setLeaderboards', response.data);
        return response.data;
      });
    },
    getPlayerLeaderboards({ commit }) {
      return api.leaderboards.getPlayerLeaderboards().then((response) => {
        commit('setPlayerLeaderboards', response.data);
        return response.data;
      });
    },
    setSelectedLeaderboardId({ commit }, data) {
      commit('setSelectedLeaderboardId', data);
    },
    clearSelectedLeaderboardId({ commit }) {
      commit('clearSelectedLeaderboardId');
    },
    resetLeaderboardsResults({ commit }) {
      commit('resetLeaderboardsResults');
    },
    setLeaderboardsDateRange({ commit }, data) {
      commit('setLeaderboardsDateRange', data);
    },
    resetLeaderboardsDateRange({ commit }) {
      commit('resetLeaderboardsDateRange');
    },
  },
};
